import { render, staticRenderFns } from "./InputTagDropdownType.vue?vue&type=template&id=c82e8010&scoped=true"
import script from "./InputTagDropdownType.vue?vue&type=script&lang=js"
export * from "./InputTagDropdownType.vue?vue&type=script&lang=js"
import style0 from "./InputTagDropdownType.vue?vue&type=style&index=0&id=c82e8010&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c82e8010",
  null
  
)

export default component.exports